import { render, staticRenderFns } from "./preview-webhook-placeholders.vue?vue&type=template&id=5ae5391e&"
import script from "./preview-webhook-placeholders.vue?vue&type=script&lang=js&"
export * from "./preview-webhook-placeholders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports